import React, { useState } from 'react'
import Published from './published'
import AddActivity from './addActivity';
import { Link } from 'react-router-dom';

const ActivityFeed = () => {
    const [display, setDisplay] = useState(1)

    return (
        <div className='container-fluid'>
            <div className="header ">
                <div className="header-body">
                    <div className="row align-items-center">
                        <div className="col">
                            <h2 className="header-title">
                                Activity Feed
                            </h2>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col">
                            <ul className="nav nav-tabs nav-overflow header-tabs">
                                <li className="nav-item">
                                    <Link className={`nav-link ${(display === 1) ? 'active' : ''}`} onClick={() => { setDisplay(1) }}>
                                        New
                                        {/* <span className="badge rounded-pill bg-secondary-soft">10</span> */}
                                    </Link>
                                </li>
                                <li className="nav-item ">
                                    <Link className={`nav-link ${(display === 2) ? 'active' : ''}`} onClick={() => { setDisplay(2) }}>
                                        Published
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container'>
                {(display === 1) ? <AddActivity /> : <Published />}
            </div>
        </div>
    )
}

export default ActivityFeed
